<template>
  <button @click="putItem" type="submit" class="btn mb-3 commitbutton"><i aria-hidden="true" class="material-icons align-middle text-2xl">settings_backup_restore</i>
    <slot></slot>
  </button>
</template>

<script>
import axios from 'axios'

  export default {

        props: {
            route:'',
            routetype:'',
        },

        data() {
          return {
            value: this.content,
          }
        },

        methods: {

          putItem: function (event) {
              $( ".commitbutton").addClass( "loading" );
              axios.this.routetype(this.route)
              .then(function (response) {
                  console.log(response);
                }).then(function (event) {
                  location.reload();
                })
          }

        },
      }
</script>
